(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["athlete-film-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('athlete-film')) {
    customElements.define('athlete-film', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const trigger = this.querySelector('[data-film-open]');
        const dialog = this.querySelector('dialog');
        const preview = this.querySelector('[data-film-preview]');
        const previewToggle = this.querySelector('[data-preview-toggle]');
        const video = this.querySelector('[data-film-full]');
        const toggle = this.querySelector('[data-film-toggle]');
        const error = this.querySelector('[data-film-error]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const playSilent = (player) => {
          player.muted = true;
          player.defaultMuted = true;
          if (!player.getAttribute('src')) player.src = trigger.dataset.videoUrl;
          player.play().catch(() => {});
        };
        this.syncPreview = () => {
          if (this.inView && !this.previewPaused && !document.hidden && !reduceMotion.matches && !document.querySelector('dialog[open]')) playSilent(preview);
          else preview.pause();
        };
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.syncPreview();
        }, { threshold: 0.2 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', this.syncPreview);
        document.addEventListener('toggle', this.syncPreview, true);
        reduceMotion.addEventListener('change', this.syncPreview);
        this.reduceMotion = reduceMotion;
        previewToggle.addEventListener('click', () => {
          this.previewPaused = !preview.paused;
          if (this.previewPaused) preview.pause();
          else playSilent(preview);
        });
        const updatePreviewControl = () => {
          previewToggle.setAttribute('aria-label', preview.paused ? previewToggle.dataset.playLabel : previewToggle.dataset.pauseLabel);
          previewToggle.querySelector('span').textContent = preview.paused ? '▶' : 'Ⅱ';
        };
        preview.addEventListener('play', updatePreviewControl);
        preview.addEventListener('pause', updatePreviewControl);
        updatePreviewControl();
        trigger.addEventListener('click', () => {
          error.hidden = true;
          document.querySelectorAll('[data-film-preview]').forEach((clip) => clip.pause());
          dialog.showModal();
          playSilent(video);
        });
        toggle.addEventListener('click', () => { if (video.paused) playSilent(video); else video.pause(); });
        video.addEventListener('play', () => { toggle.textContent = toggle.dataset.pauseLabel; });
        video.addEventListener('pause', () => { toggle.textContent = toggle.dataset.playLabel; });
        this.querySelector('[data-film-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => {
          video.pause();
          video.removeAttribute('src');
          video.load();
          trigger.focus({ preventScroll: true });
          document.querySelectorAll('athlete-film').forEach((film) => film.syncPreview?.());
        });
        video.addEventListener('error', () => { if (dialog.open) error.hidden = false; });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.syncPreview);
        document.removeEventListener('toggle', this.syncPreview, true);
        this.reduceMotion?.removeEventListener('change', this.syncPreview);
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["athlete-interaction-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('athlete-interaction-motion')) {
    customElements.define('athlete-interaction-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const { signal } = this.events;
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.items = [];
        this.buttons = [];
        const landing = this.closest('.athlete-landing');
        const hoverPreference = window.matchMedia('(hover: hover) and (pointer: fine)');
        landing.querySelectorAll('.athlete-motion-button').forEach((button) => {
          const text = button.querySelectorAll('.athlete-motion-button__text');
          if (!text.length) return;
          const state = { text, hovered: false, focused: false, tween: null };
          this.buttons.push(state);
          const update = () => {
            state.tween?.kill();
            if (this.preference.matches || !window.gsap || button.disabled) {
              this.resetButton(state);
              return;
            }
            state.tween = window.gsap.to(text, {
              yPercent: state.hovered || state.focused ? -100 : 0,
              duration: 0.48,
              ease: 'power3.inOut',
              overwrite: true
            });
          };
          button.addEventListener('pointerenter', (event) => {
            state.hovered = event.pointerType === 'mouse' && hoverPreference.matches;
            if (state.hovered) update();
          }, { signal });
          button.addEventListener('pointerleave', () => {
            if (!state.hovered) return;
            state.hovered = false;
            update();
          }, { signal });
          button.addEventListener('focus', () => {
            state.focused = button.matches(':focus-visible');
            if (state.focused) update();
          }, { signal });
          button.addEventListener('blur', () => { state.focused = false; update(); }, { signal });
        });
        landing.querySelectorAll('.athlete-faq__item').forEach((details) => {
          const summary = details.querySelector('summary');
          const panel = details.querySelector('[data-faq-panel]');
          if (!summary || !panel) return;
          const state = { details, summary, panel, expanded: details.open, tween: null };
          this.items.push(state);
          summary.setAttribute('aria-expanded', String(state.expanded));
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const height = details.open ? panel.getBoundingClientRect().height : 0;
            const opacity = details.open ? getComputedStyle(panel).opacity : 0;
            state.tween?.kill();
            state.expanded = !state.expanded;
            summary.setAttribute('aria-expanded', String(state.expanded));
            if (this.preference.matches || !window.gsap) {
              this.finish(state);
              return;
            }
            details.open = true;
            panel.style.height = `${height}px`;
            panel.style.opacity = opacity;
            state.tween = window.gsap.to(panel, {
              height: state.expanded ? panel.scrollHeight : 0,
              opacity: state.expanded ? 1 : 0,
              duration: state.expanded ? 0.42 : 0.36,
              ease: 'power2.inOut',
              overwrite: true,
              onComplete: () => this.finish(state)
            });
          }, { signal });
        });
        this.onPreferenceChange = () => {
          if (!this.preference.matches) return;
          this.items.forEach((item) => this.finish(item));
          this.buttons.forEach((button) => this.resetButton(button));
        };
        this.preference.addEventListener('change', this.onPreferenceChange);
        window.addEventListener('resize', () => this.items.forEach((item) => {
          if (item.tween) this.finish(item);
        }), { signal, passive: true });
      }
      finish(state) {
        state.tween?.kill();
        state.tween = null;
        state.details.open = state.expanded;
        state.summary.setAttribute('aria-expanded', String(state.expanded));
        state.panel.style.removeProperty('height');
        state.panel.style.removeProperty('opacity');
      }
      resetButton(state) {
        state.tween?.kill();
        state.tween = null;
        state.text.forEach((element) => {
          element.style.removeProperty('transform');
          element.style.removeProperty('translate');
          element.style.removeProperty('rotate');
          element.style.removeProperty('scale');
        });
      }
      disconnectedCallback() {
        this.items?.forEach((item) => this.finish(item));
        this.buttons?.forEach((button) => this.resetButton(button));
        this.events?.abort();
        this.events = null;
        this.preference?.removeEventListener('change', this.onPreferenceChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
